import { createAction, props } from '@ngrx/store';

export const toggleSidebar = createAction('[Sidebar Actions] toggleSidebar', props<{ isOpened: boolean }>());
